/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import DateRangePicker from '@material-ui/lab/DateRangePicker';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import {
  color,
  desktopVW,
  mobileVW,
  minTablet,
} from '../../styles';
import { InputField } from '../../shared/Inputs';
import { dayInMs } from '../../utils';

export const DateSelector = ({
  data: {
    startDate, returnDate,
  },
  setValue, value,
} : { data : { startDate: string, returnDate: string }, setValue: any, value: any}) => {
  const disableDates = (date: any) => {
    if (!value[1]) {
      return date.toLocaleDateString() === new Date(value[0].getTime() + Number(dayInMs) * 1).toLocaleDateString() || date.toLocaleDateString() === new Date(value[0].getTime() + Number(dayInMs) * 2).toLocaleDateString();
    }
    return undefined;
  };

  return (
    <StyledDateSelector>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledDateRangePicker
          label="Advanced keyboard"
          value={value}
          maxDate={new Date(value[0].getTime() + Number(dayInMs) * 100)}
          minDate={new Date().getTime()}
          shouldDisableDate={disableDates}
          onChange={(newValue : [string, string]) => setValue(newValue)}
          renderInput={(startProps : any, endProps : any) => (
            <>
              <InputField title={startDate} ref={startProps.inputRef} {...startProps.inputProps} />
              <InputField title={returnDate} ref={endProps.inputRef} {...endProps.inputProps} />
            </>
          )}
        />
      </LocalizationProvider>
    </StyledDateSelector>
  );
};

const StyledDateSelector = styled.div`
  margin-top: ${mobileVW(30)};
  position: relative;

  ${minTablet} {
    margin-top: ${desktopVW(30)};
  }
`;

// @ts-ignore
const StyledDateRangePicker = styled(DateRangePicker)`
  color: ${color.black};
`;
